import { render } from "./EmailsContent.vue?vue&type=template&id=f2e05d7c&ts=true"
import script from "./EmailsContent.vue?vue&type=script&lang=ts"
export * from "./EmailsContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__